import { render, staticRenderFns } from "./base-column-check.vue?vue&type=template&id=f0dca264&scoped=true&"
import script from "./base-column-check.vue?vue&type=script&lang=js&"
export * from "./base-column-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dca264",
  null
  
)

export default component.exports